const META_PIXEL_ID = '2946650432349308';
const META_PIXEL_SCRIPT_ID = 'meta-pixel-script';

interface MetaPixelFunction {
    (...args: unknown[]): void;
    callMethod?: (...args: unknown[]) => void;
    queue: unknown[][];
    loaded: boolean;
    version: string;
    push: MetaPixelFunction;
}

declare global {
    interface Window {
        fbq?: MetaPixelFunction;
        _fbq?: MetaPixelFunction;
    }
}

let initialized = false;

/**
 * Loads Meta Pixel only on the public map after cookie consent is granted.
 * This utility is called by App, which is mounted exclusively for the `/` route.
 */
export const initializeMetaPixel = (): void => {
    if (!import.meta.env.PROD) return;
    if (initialized || window.location.pathname !== '/') return;

    if (!window.fbq) {
        const fbq = function (...args: unknown[]) {
            if (fbq.callMethod) {
                fbq.callMethod(...args);
            } else {
                fbq.queue.push(args);
            }
        } as MetaPixelFunction;

        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = fbq;
    }

    if (!document.getElementById(META_PIXEL_SCRIPT_ID)) {
        const script = document.createElement('script');
        script.id = META_PIXEL_SCRIPT_ID;
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
    }

    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
    initialized = true;
};

/**
 * Records a successful public-map search without sending the user's location
 * or care-need selections to Meta.
 */
export const trackMetaSearch = (resultCount: number): void => {
    if (!initialized || window.location.pathname !== '/' || !window.fbq) return;

    window.fbq('track', 'Search', {
        search_string: 'care_home_search',
        content_category: 'care_homes',
        result_count: resultCount
    });
};
